'use strict';

var _ = require('lodash');
var BaseStaticView = require('actions/shared/AbstractStaticView');
var tpl = require('actions/dhcpReservations/staticReservation.html');
var twig = require('twig').twig;

/**
 * Renders a text-only version of an individual DHCP reservation
 */
module.exports = BaseStaticView.extend({
  /**
   * @name actions/dhcpReservations/StaticReservationView#model
   * @type {actions/dhcpReservations/DhcpReservations}
   */

  template: twig({data: tpl}),

  templateContext: function() {
    var baseHelpers = BaseStaticView.prototype.templateContext.apply(this);

    return _.extend({}, baseHelpers);
  },
});
